import BasicRepository, { ListArgs } from "./basicRepository";
import Client from "../client";
import { TaskResource, ResourceCollection } from "client/resources";
import { TaskDetailsResource } from "client/resources/taskDetailsResource";
import { TaskName } from "client/resources/taskResource";

interface TaskListArgs extends ListArgs {
    name?: TaskName;
    node?: string;
    tenant?: string;
    environment?: string;
    project?: string;
    taskName?: string;
    states?: string;
    running?: boolean;
    active?: boolean;
    hasPendingInterruptions?: boolean;
    ids?: string;
}

interface TaskDetailsArgs {
    verbose: boolean;
    tail: number;
}

export interface StatsResourceCollection extends ResourceCollection<TaskResource<any>> {
    TotalCounts: { [state: string]: number };
}

class TaskRepository extends BasicRepository<TaskResource<any>, TaskResource<any>, TaskListArgs> {
    constructor(client: Client) {
        super("Tasks", client);
    }

    details(task: TaskResource<any>, args: TaskDetailsArgs) {
        return this.client.get<TaskDetailsResource>(task.Links["Details"], args);
    }

    getQueuedBehind(task: TaskResource<any>, args?: { skip?: number, take?: number }): Promise<ResourceCollection<TaskResource<any>>> {
        return this.client.get(task.Links["QueuedBehind"], args);
    }

    getRaw(task: TaskResource<any>) {
        return this.client.getRaw(task.Links["Raw"]);
    }

    filter(args: any): Promise<ResourceCollection<TaskResource<any>>> {
        return this.client.get<ResourceCollection<TaskResource<any>>>(this.client.getRootDocument().Links["Tasks"], args);
    }

    rerun(task: TaskResource<any>): Promise<TaskResource<any>> {
        return this.client.post(task.Links["Rerun"]);
    }

    cancel(task: TaskResource<any>) {
        return this.client.post(task.Links["Cancel"]);
    }

    changeState(task: TaskResource<any>, state: any, reason: any): Promise<TaskResource<any>> {
        return this.client.post(task.Links["State"], { state, reason });
    }

    list(args?: TaskListArgs): Promise<StatsResourceCollection> {
        return super.list(args) as Promise<StatsResourceCollection>;
    }
}

export default TaskRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/taskRepository.ts